/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Attr_Auction_ReviewInputs */

const cs_sreality_attr_auction_review = /** @type {(inputs: Sreality_Attr_Auction_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protokol z dražby (PDF)`)
};

const en_sreality_attr_auction_review = /** @type {(inputs: Sreality_Attr_Auction_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auction review (PDF)`)
};

/**
* | output |
* | --- |
* | "Auction review (PDF)" |
*
* @param {Sreality_Attr_Auction_ReviewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_attr_auction_review = /** @type {((inputs?: Sreality_Attr_Auction_ReviewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Attr_Auction_ReviewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_attr_auction_review(inputs)
	return cs_sreality_attr_auction_review(inputs)
});